var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"knowledge-hero-backround bg-green-500 -mx-6 -mt-6"},[_c('div',{staticClass:"flex items-center justify-center p-10"},[_c('Search')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }